<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { num, signed } from './format';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // training_load of a report: the athlete's Low, High and Peak training load at the start and now or at the end.
  export let start: any;
  export let finish: any;

  $: total = (s: any) => (s ? (s.low ?? 0) + (s.high ?? 0) + (s.peak ?? 0) : null);
  $: rows = [
    { label: $_('report.load.total'), from: total(start), to: total(finish) },
    { label: $_('report.load.low'), from: start?.low ?? null, to: finish?.low ?? null },
    { label: $_('report.load.high'), from: start?.high ?? null, to: finish?.high ?? null },
    { label: $_('report.load.peak'), from: start?.peak ?? null, to: finish?.peak ?? null },
  ];
  const d = (v: number) => (Math.abs(v) < 10 ? 1 : 0);
</script>

<div class="space-y-2 text-sm">
  {#each rows as r}
    <div class="flex items-baseline justify-between gap-2">
      <span>
        <span class="text-zinc-600">{r.label}</span><br />
        <span class="tabular-nums">{num(r.from, d(r.from ?? 0))} → {num(r.to, d(r.to ?? 0))}</span>
      </span>
      {#if r.from !== null && r.to !== null}
        <span class="tabular-nums font-medium {r.to - r.from > 0 ? 'text-green-600' : 'text-zinc-600'}">{signed(r.to - r.from, Math.abs(r.to - r.from) < 10 ? 1 : 0)}</span>
      {/if}
    </div>
  {/each}
</div>
